import { LandingNode } from '@mmt/bus/src/schema.type';
import React from 'react';

export interface BusSharedNavigation {
  openBus(props: any): void;
  openSeatBooking(props: any): void;
}

export type SharedTrackingData = string | Record<string, string>;
export interface BusSharedTracker {
  trackRisBusCrossSell(pageName: string, data: SharedTrackingData, isLoadEvent?: boolean): void
  trackLandingEvent(data: SharedTrackingData): void;
}

interface BusRatingComponentProps{
  rating?: number,
  maxRating?: number,
  noRatingsText?: string,
  gradientColor?: string[],
}

export type BusSharedComponents = {
  BusRatingComponent: React.ComponentType<BusRatingComponentProps>;
  BusTrainCrossSell: React.ComponentType<any>;
  BusDecorator: React.ComponentType<any>;
  BusSearchWidget: React.FC<{ isB2B: boolean }>;
};

export interface BusSharedListingActions {
  setCrossSellPrimaryLob(...args: any): any;
  initLanding(args: { railsBusCommonLanding: boolean; isPremium?: boolean }): void;
}

export interface BusSharedUtils {
  getBusPremiumLandingData: () => Promise<LandingNode[]>;
}

export interface BusSharedModule {
  getBusReducers(): any
  getBusSharedNavigation(): BusSharedNavigation
  getBusSharedTracker(): BusSharedTracker
  getBusSharedComponents(): BusSharedComponents
  getBusSharedListingActions(): BusSharedListingActions;
  getBusSharedUtils(): BusSharedUtils;
}
